import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotRecommend from "./components/HotRecommend";
import LatestUpdate from "./components/LatestUpdate";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <LatestUpdate />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "汗汗漫画-更新最快的漫画网-好看的免费漫画大全-无遮挡韩漫",
            "description": "汗汗漫画以更新速度最快为核心优势，提供海量好看的免费漫画大全和无遮挡韩漫。每日更新热门漫画、热血漫画、恋爱漫画、耽美漫画。",
            "url": "http://i0767.com/",
            "inLanguage": "zh-Hans",
            "isPartOf": {
              "@type": "WebSite",
              "name": "汗汗漫画",
              "url": "http://i0767.com/"
            },
            "about": {
              "@type": "Thing",
              "name": "在线漫画阅读",
              "description": "提供免费漫画在线阅读服务，涵盖热血、恋爱、玄幻、耽美、韩漫等品类"
            }
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "汗汗漫画更新速度快吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "汗汗漫画以更新速度最快为宣传点，采用实时同步技术确保漫画章节第一时间上线。日漫、韩漫、国漫三大品类均保持极速更新节奏，新章节发布后30分钟内即可阅读。"
                }
              },
              {
                "@type": "Question",
                "name": "汗汗漫画是免费的吗？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "是的，汗汗漫画提供完全免费的漫画阅读服务。所有漫画资源均可免费在线阅读，无需付费订阅。平台通过广告和会员增值服务维持运营，基础阅读功能永久免费。"
                }
              },
              {
                "@type": "Question",
                "name": "汗汗漫画有哪些类型的漫画？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "汗汗漫画涵盖热血漫画、恋爱漫画、玄幻漫画、耽美漫画、恐怖漫画、搞笑漫画、无遮挡韩漫、国产漫画、日本漫画等九大品类，拥有超过50000部漫画资源，满足各类漫画爱好者的阅读需求。"
                }
              },
              {
                "@type": "Question",
                "name": "无遮挡韩漫是什么意思？",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "无遮挡韩漫指的是完整呈现韩国漫画原版内容，不进行删减、遮挡或修改的韩漫阅读体验。汗汗漫画坚持原汁原味呈现韩漫内容，让读者享受完整、真实的阅读体验。"
                }
              }
            ]
          }),
        }}
      />
    </>
  );
}